import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Modal from "../../../components/Modal";
import ScheduleForm from "./ScheduleForm";
import { useGetIpAddress } from "../../TimeClock/ClockIn/api";
import { useMyRequests } from "../api";
import { useUser } from "../../../utils/hooks/user";
import "./styles.scss";

function AddSchedule({ isOpen, onClose, setData, setTotalItems }) {
	const { t } = useTranslation();
	const user = useUser();
	const { ip, getIp } = useGetIpAddress();
	const { loading, error, create } = useMyRequests();

	const onFinish = useCallback((data) => {
		if (!user) {
			return;
		}

		const request = {
			user: user?.id,
			type: "schedule",
			device: "web-application",
			ip: ip ? ip : "",
			data,
			namespace: "schedule",
		}
		create(request, (response) => {
			onClose();
			setData((prev) => (prev || [])?.concat(response));
			setTotalItems((prev) => prev + 1);
			toast.success(t("request-created-successfully"));
		})
	}, [user, ip, create, setData, setTotalItems, onClose, t]);

	useEffect(() => {
		const controller = new AbortController();
		getIp(controller);
		return () => controller.abort();
	}, [getIp]);

	return (
		<Modal
			className="add-schedule-modal modal-dialog-centered modal-lg pb-0 shadow-none"
			title={t("add-schedule-request")}
			isOpen={isOpen}
			toggle={onClose}
			size="lg"
			scrollable
			centered
			footer={undefined}
		>
			{isOpen && (
				<ScheduleForm
					loading={loading}
					error={error}
					onClose={onClose}
					onFinish={onFinish}
					values={undefined}
					mode={undefined}
				/>
			)}
		</Modal>
	)
}

export default AddSchedule;
